export const ITERATION = 10000
export const KEY_ZISE = 256 / 32
export const SALT = [0x0e, 0x1a, 0x04, 0x12, 0x0f, 0x18, 0x1f, 0x06]
  .map(chart => ('0' + chart.toString(16)).slice(-2))
  .join('')
